// extracted by mini-css-extract-plugin
export default {"success":"UploadResult_success__8CaXr","error":"UploadResult_error__crzMB","responseFirst":"UploadResult_responseFirst__rYBpZ","responseSecond":"UploadResult_responseSecond__nWL1j"};